import React from 'react';

const portfolio = () => {
    return (
        <section id="portfolio">
            <div className="row">
                <div className="twelve columns collapsed">
                    <h1>Check Out Some of My Work.</h1>
                    {/* portfolio-wrapper */}
                    <div id="portfolio-wrapper" className="bgrid-quarters s-bgrid-thirds cf">
                    <div className="columns portfolio-item">
                            <div className="item-wrap">
                                <a href="#modal-02" >
                                    <img src="images/promocode-demo.jpeg" />
                                    <div className="overlay">
                                        <div className="portfolio-item-meta">
                                            <h5>Promo Code Classes</h5>
                                            <p>Code Segment</p>
                                        </div>
                                    </div>
                                    <div className="link-icon"><i className="icon-plus" /></div>
                                </a>
                            </div>
                        </div> 
                        <div className="columns portfolio-item">
                            <div className="item-wrap">
                                <a  href="#modal-01" >
                                    <img src="images/calculator.jpeg" />
                                    <div className="overlay">
                                        <div className="portfolio-item-meta">
                                            <h5>Tax Liability Calculator</h5>
                                            <p>App</p>
                                        </div>
                                    </div>
                                    <div className="link-icon"><i className="icon-plus" /></div>
                                </a>
                            </div>
                        </div>
                        <div className="columns portfolio-item">
                            <div className="item-wrap">
                                <a href="#modal-03" >
                                    <img src="images/form-helper.jpeg" />
                                    <div className="overlay">
                                        <div className="portfolio-item-meta">
                                            <h5>React Form Helper Components</h5>
                                            <p>Library</p>
                                        </div>
                                    </div>
                                    <div className="link-icon"><i className="icon-plus" /></div>
                                </a>
                            </div>
                        </div> 
                        <div id="modal-01" className="popup-modal mfp-hide">
                            <div className="description-box">
                                <h4>Tax Liability Calculator</h4>
                                <p> 
                                    <a target="_blank" href="https://lukejsimonetti.com">View Demo</a>
                                    <br/>
                                    This app is used to calculate the 2018 tax liability for individuals or individuals who utilize a Housing Allowance. The data used to calculate the tax liabilities originate from local state and Federal publications which are not guaranteed for accuracy. </p> 
                                <span className="categories"><i className="fa fa-tag" />React</span>
                            </div>
                            <div className="link-box">
                                <a target="_blank" href="https://lukejsimonetti.com"> View Demo</a>
                                <a className="popup-modal-dismiss">Close</a>
                            </div>
                        </div>
                        <div id="modal-02" className="popup-modal mfp-hide">
                            <div className="description-box">
                                <h4>Promo Code Classes</h4>
                                <p> 
                                    <a target="_blank" href="https://github.com/lukejsimonetti/PromoCodeDemo">View Source Code</a>
                                    <br/>
                                    This repo demonstrates a segment of code I've written for an online shopping cart API. </p> 
                                <span className="categories"><i className="fa fa-tag" />PHP, Doctrine, PHPUnit</span>
                            </div>
                            <div className="link-box">
                                <a target="_blank" href="https://github.com/lukejsimonetti/PromoCodeDemo"> View Demo</a>
                                <a className="popup-modal-dismiss">Close</a>
                            </div>
                        </div>
                        <div id="modal-03" className="popup-modal mfp-hide">
                            <div className="description-box">
                                <h4>React Form Helper Components</h4>
                                <p> 
                                    <a target="_blank" href="https://github.com/lukejsimonetti/react-form-helper-components">View Source Code</a>
                                    <br/>
                                    A library of react helper components using redux form and reactstrap. 
                                    I built this library because of the many react apps I've had to build the last year. 
                                    I ended up needing several resuable components. This repo is a work in progress.</p> 
                                <span className="categories"><i className="fa fa-tag" />React, Redux Form, reactstrap, react-datetime</span>
                            </div>
                            <div className="link-box">
                                <a target="_blank" href="https://github.com/lukejsimonetti/react-form-helper-components"> View Demo</a>
                                <a className="popup-modal-dismiss">Close</a>
                            </div>
                        </div>

                    </div> {/* portfolio-wrapper end */}
                </div> {/* twelve columns end */}

            </div> {/* row End */}
        </section>
    )
}

export default portfolio


// WEBPACK FOOTER //
// ./src/main/portfolio.js